import {UI} from "../../../stem-core/ui/UIBase";

import {Dispatcher} from "../../../stem-core/base/Dispatcher";


export const WidgetActiveRouteElementBuilder = (BaseClass: typeof UI.Element<any> = UI.Element) => class Element extends BaseClass {
    declare ["constructor"]: typeof Element;

    // Left untyped: onMount stores the subclass instance here, and callers read their own members off
    // it. Naming the class the builder returns would narrow it to this base
    static instance;

    dispatchHeightChange() {
        // TODO @cleanup why the dispatch and not just call a function?
        const desiredWidgetHeight = this.computeHeight();
        Dispatcher.Global.dispatch("widgetAnimationUpdateHeight", desiredWidgetHeight);
    }

    /*
    * This method should tell the intended iframe height of the widget when this class is the active route element.
    * The height should not include any extra height made by the error banner appearance.
    */
    computeHeight() {
        return this.getHeight();
    }

    onMount() {
        this.constructor.instance = this;

        super.onMount();
    }
};

export const WidgetActiveRouteElement = WidgetActiveRouteElementBuilder();
